import { useEffect } from "react";
import { selectVariant } from "../../utils/adVariant";

export function YandexFullScreen({ isFull, isDesktop, options }) {
    const option = selectVariant(options, isFull, isDesktop);
    const optionObj = Array.isArray(option) ? option[0] : option;
    const blockId = optionObj && optionObj.blockId;

    useEffect(() => {
        if (!blockId) {
            return;
        }

        window.yaContextCb = window.yaContextCb || [];

        window.yaContextCb.push(() => {
            Ya.Context.AdvManager.render(optionObj);
        });
    }, [blockId]);

    return null;
}
